import { useCookie, useNuxtApp } from '#app';
import { useLocalsStore } from '~/stores/locals';

const getSubValueFromCookie = (cookieValue, subKey) => {
  if (!cookieValue) {
    return null;
  }

  const decodedValue = decodeURIComponent(cookieValue);
  const parts = decodedValue.split('3_87_');

  const keysToTry = [`${subKey}1`, subKey];

  for (const keyToFind of keysToTry) {
    for (const part of parts) {
      const subParts = part.split('1_92_');
      if (subParts.length === 2 && subParts[0] === keyToFind) {
        return subParts[1];
      }
    }
  }

  return null;
};

export const generateLogin365FingerPrint = async (cookieComposer) => {
  const nuxtApp = useNuxtApp();
  const getCookie = cookieComposer || ((name, opts) => nuxtApp.runWithContext(() => useCookie(name, opts)));

  const localsStore = useLocalsStore();
  const persistentLoginEnabledKS = localsStore?.data?.killswitches?.persistentLoginKSEnabled;
  if (persistentLoginEnabledKS) {
    const miscgcsCookie = getCookie('MISCGCs');
    const login365CustomerValue = getSubValueFromCookie(miscgcsCookie.value, 'Login365Customer');
    const isLogin365Customer = login365CustomerValue === 'Y' || false;

    const persistentLoginHeaders = {
      'X-Macys-Login365customer': isLogin365Customer,
    };

    const deviceFingerPrintCookie = getCookie('sys_client_dfp');
    const deviceFingerprintHeaders = {};
    if (deviceFingerPrintCookie.value) {
      deviceFingerprintHeaders['X-Macys-Devicefingerprint'] = deviceFingerPrintCookie.value;
    }

    return Object.assign(deviceFingerprintHeaders, persistentLoginHeaders);
  }
  return {};
};

export default {
  generateLogin365FingerPrint,
};
